module.exports = __webpack_public_path__ + "static/media/calculate-meter-hint.e0f2eb37.png";